// project imports
import { processDateFieldInput, processDateFieldOutput } from 'utils/processors';
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    estimatedStartDate: 'estimatedStartDate' in (values || {}) ? processDateFieldInput(values.estimatedStartDate) : null,
    estimatedEndDate: 'estimatedEndDate' in (values || {}) ? processDateFieldInput(values.estimatedEndDate) : null
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    id: undefined,
    estimatedStartDate:
        'estimatedStartDate' in (values || {}) ? processDateFieldOutput(values.estimatedStartDate, 'yyyy-MM-dd HH:mm') : undefined,
    estimatedEndDate: 'estimatedEndDate' in (values || {}) ? processDateFieldOutput(values.estimatedEndDate, 'yyyy-MM-dd HH:mm') : undefined
});
